<template>
  <div class="typing-indicator">
    <div class="typing-bubble">
      <span />
      <span />
      <span />
    </div>
  </div>
</template>

<style scoped lang="scss">
.typing-indicator {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.typing-bubble {
  background: $container-bg;
  padding: 16px 20px;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  display: flex;
  gap: 6px;
  align-items: center;
  box-shadow: 0 2px 8px rgba($black, 0.08);
  border: 1px solid $neutral-border-color;
}

.typing-bubble span {
  width: 8px;
  height: 8px;
  background: $color-grey-400;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.typing-bubble span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-bubble span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
